<!--
 * @Author: gaobin
 * @Date: 2025-03-19 11:16:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-05-24 15:47:40
 * @Description: 简单封装的加载动画
-->
<template>
  <view
    v-if="globalLoadingState"
    class="loading-page"
    :style="{
      backgroundColor: 'rgba(0, 0, 0,' + overlayOpacity1 + ')',
      top: boxTopDistance,
    }"
  >
    <view
      class="loading-box absolute-layout flex-column-center-center"
      :style="{ backgroundColor: 'rgba(0, 0, 0,' + overlayOpacity2 + ')' }"
    >
      <view class="loader"></view>
      <!-- <text class="l-text">{{ t('loading') }}</text> -->
    </view>
  </view>
</template>

<script setup>
import { useLoading } from '@/composables/useGlobalLoading';

const { globalLoadingState, overlayOpacity1, overlayOpacity2, loadingTop } = useLoading();
// const { t } = useI18n();
const boxTopDistance = computed(() => {
  return loadingTop.value
    ? `calc(88rpx + ${loadingTop.value} + var(--status-bar-height))`
    : 'calc(88rpx + var(--status-bar-height))';
});
</script>
<style lang="scss" scoped src="./style.scss"></style>
